import { createEvent, restore, sample } from 'effector'
import { fx, path } from '../../../../libs'
import { ServiceItem } from './types'
import { $params, toPath } from '../../../../features/router'
import { RequestError } from '../../../../shared/errorResponse'
import { getAllServiceLanguages, loadAllLanguages } from '../list/model'
import { setRequestSuccess } from '../../../../features/notifications'

export const translationItemMounted = createEvent()

export const submitUpdateService = createEvent<ServiceItem>()

export const setError = createEvent<RequestError>()

export const getTranslationItem = fx<any, any>({
  method: 'GET',
  url: `/translation/service/translation/list`,
})

export const updateServiceItem = fx<ServiceItem, void>({
  method: 'PUT',
  url: '/translation/service/translation/upload',
})

export const $translationItem = restore<ServiceItem[]>(
  getTranslationItem.doneData.map((a) => a.body.items),
  [],
)

export const $error = restore(setError, {
  message: '',
  code: 0,
})

sample({
  // @ts-ignore
  clock: translationItemMounted,
  source: $params,
  fn: (params) => {
    let serviceName
    let lang
    if (params) {
      serviceName = params.serviceName
      lang = params.lang
    }

    return {
      url: `/translation/service/translation/list?where={"service":"${serviceName}", "lang":"${lang}"}`,
    }
  },
  target: getTranslationItem,
})

sample({
  clock: submitUpdateService,
  fn: (serviceItem) => {
    return {
      url: `/translation/service/translation/upload`,
      body: { ...serviceItem },
    }
  },
  target: updateServiceItem,
})

sample({
  clock: updateServiceItem.doneData,
  target: [translationItemMounted, loadAllLanguages],
})

sample({
  clock: updateServiceItem.doneData,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: updateServiceItem.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})

// Не удалось догрузить языки сервиса — показываем ошибку и уходим на список
sample({
  clock: getAllServiceLanguages.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})

sample({
  clock: getAllServiceLanguages.failData,
  target: toPath.prepend(path.translations.services.entry),
})
